export const queryKeys = {
  // Auth keys
  auth: {
    all: ['auth'] as const,
    currentUser: ['auth', 'currentUser'] as const,
  },

  // Recipe keys
  recipes: {
    all: ['recipes'] as const,
    lists: () => ['recipes', 'list'] as const,
    list: (params?: any) => ['recipes', 'list', params] as const,
    infinite: (params?: any) => ['recipes', 'infinite', params] as const,
    details: () => ['recipes', 'detail'] as const,
    detail: (id: string) => ['recipes', 'detail', id] as const,
    bookmarked: () => ['recipes', 'bookmarked'] as const,
    trending: () => ['recipes', 'trending'] as const,
    featured: () => ['recipes', 'featured'] as const,
    interactions: (id: string) => ['recipes', 'interactions', id] as const,
    bulkInteractions: (ids: string[]) =>
      ['recipes', 'interactions', 'bulk', ids] as const,
  },

  // User keys
  users: {
    all: ['users'] as const,
    lists: () => ['users', 'list'] as const,
    list: (params?: any) => ['users', 'list', params] as const,
    details: () => ['users', 'detail'] as const,
    detail: (id: string) => ['users', 'detail', id] as const,
    followers: (id: string) => ['users', 'followers', id] as const,
    following: (id: string) => ['users', 'following', id] as const,
  },

  // Creator keys
  creators: {
    all: ['creators'] as const,
    lists: () => ['creators', 'list'] as const,
    list: (params?: any) => ['creators', 'list', params] as const,
    details: () => ['creators', 'detail'] as const,
    detail: (id: string) => ['creators', 'detail', id] as const,
    featured: () => ['creators', 'featured'] as const,
    top: () => ['creators', 'top'] as const,
  },

  // Equipment keys
  equipment: {
    all: ['equipment'] as const,
    lists: () => ['equipment', 'list'] as const,
    list: (params?: any) => ['equipment', 'list', params] as const,
    details: () => ['equipment', 'detail'] as const,
    detail: (id: string) => ['equipment', 'detail', id] as const,
    featured: () => ['equipment', 'featured'] as const,
    category: (category: string) =>
      ['equipment', 'category', category] as const,
  },

  // Payments keys
  payments: {
    all: ['payments'] as const,
    list: (params?: any) => ['payments', 'list', params] as const,
    detail: (id: string) => ['payments', 'detail', id] as const,
  },

  // Subscriptions keys
  subscriptions: {
    all: ['subscriptions'] as const,
    list: (params?: any) => ['subscriptions', 'list', params] as const,
    detail: (id: string) => ['subscriptions', 'detail', id] as const,
  },

  // Payouts keys
  payouts: {
    all: ['payouts'] as const,
    list: (params?: any) => ['payouts', 'list', params] as const,
    detail: (id: string) => ['payouts', 'detail', id] as const,
  },

  // Search keys
  search: {
    all: ['search'] as const,
    query: (query: string, type?: string) => ['search', query, type] as const,
    suggestions: (query: string, type?: string) =>
      ['search', 'suggestions', query, type] as const,
    autocomplete: (query: string, type?: string) =>
      ['search', 'autocomplete', query, type] as const,
    saved: {
      all: ['search', 'saved'] as const,
      list: (params?: { page?: number; size?: number }) =>
        ['search', 'saved', 'list', params] as const,
      detail: (id: string) => ['search', 'saved', 'detail', id] as const,
    },
  },

  // Comment keys
  comments: {
    all: ['comments'] as const,
    recipe: (recipeId: string) => ['comments', 'recipe', recipeId] as const,
    detail: (id: string) => ['comments', 'detail', id] as const,
    user: (params?: any) => ['comments', 'user', params] as const,
  },

  // Notification keys
  notifications: {
    all: ['notifications'] as const,
    list: () => ['notifications', 'list'] as const,
    unread: () => ['notifications', 'unread'] as const,
  },

  // Recommendations keys
  recommendations: {
    all: ['recommendations'] as const,
    list: () => ['recommendations', 'list'] as const,
    trending: (params?: any) =>
      ['recommendations', 'trending', params] as const,
    featuredCreators: () => ['recommendations', 'featuredCreators'] as const,
    personalized: () => ['recommendations', 'personalized'] as const,
  },
} as const;
